import { List, Map } from 'immutable'
import moment from 'moment'
import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Button } from 'semantic-ui-react'
import { dataTableItemUpdateSuccess } from '~/datatable/actions'
import { Field, Group, Info, InfoGroup, Submit } from '~/form'
import NoteEditor from '../note'
import Contacts from './contacts'
import Files from './files'
import Messages from './messages'

class OrganizationEdit extends Component {
  render() {
    let { formUpdate, formState, onCancel, itemId, active } = this.props

    let { values } = formState
    let item = values.get(itemId, false)

    if (!active || !Map.isMap(item)) return null

    return (
      <Fragment>
        <div className="datatable-action-panels">
          <div className="datatable-action-panel datatable-action-panel--left">
            <div className="datatable-action-content">
              <InfoGroup>
                <Info
                  label="Luotu"
                  text={moment(item.get('created_at'), 'YYYY-MM-DD HH:mm:ss.SSSZZ').format('DD.MM.YYYY - HH:mm')}
                />
                <Info
                  label="Päivitetty"
                  text={moment(item.get('updated_at'), 'YYYY-MM-DD HH:mm:ss.SSSZZ').format('DD.MM.YYYY - HH:mm')}
                />
              </InfoGroup>
              <Group>
                <div className="form-columns form-columns--3">
                  <Field
                    label="Organisaation nimi"
                    type="text"
                    name={itemId + '.name'}
                    key={itemId + '.name'}
                    onChange={formUpdate}
                    formState={formState}
                  />
                  <Field
                    label="Y-tunnus"
                    type="text"
                    name={itemId + '.businessid'}
                    key={itemId + '.businessid'}
                    onChange={formUpdate}
                    formState={formState}
                  />
                  <Field
                    label="Pääsykoodi"
                    type="text"
                    name={itemId + '.data.passcode'}
                    key={itemId + '.data.passcode'}
                    onChange={formUpdate}
                    formState={formState}
                  />
                </div>
              </Group>
              <Group>
                <Button
                  content="Avaa yrityksen aineistot"
                  size="tiny"
                  color="green"
                  icon="external alternate"
                  as="a"
                  href={`${process.env.APPROVAL_URL}/yritys/${itemId}`}
                  target="_blank"
                />
                {item.getIn(['data', 'pipedrive_org_id'], false) ? (
                  <Button
                    content="Pipedrive"
                    size="tiny"
                    color="black"
                    icon="columns"
                    onClick={e =>
                      e.preventDefault() &
                      window.open(
                        `https://onlinetechnologygroupoy.pipedrive.com/organization/${item.getIn([
                          'data',
                          'pipedrive_org_id',
                        ])}`,
                        '_blank'
                      )
                    }
                  />
                ) : null}
                {item.getIn(['data', 'pipedrive_deal_ids'], []).map((id, i) => {
                  return (
                    <Button
                      content={`Diili ${i + 1}`}
                      size="tiny"
                      color="gray"
                      icon="columns"
                      onClick={e =>
                        e.preventDefault() &
                        window.open(`https://onlinetechnologygroupoy.pipedrive.com/deal/${id}`, '_blank')
                      }
                    />
                  )
                })}
              </Group>
              <Group title="Yhteyshenkilöt">
                <Contacts organization={item} />
              </Group>
              <Group title="Asiakkaan lisäämät tiedostot">
                <Files organization={item} />
              </Group>
              <Group title="Viestit">
                <Messages organization={item} />
              </Group>
            </div>
          </div>
          <div className="datatable-action-panel datatable-action-panel--right">
            <Group title="Organisaation muistiinpanot">
              <NoteEditor entity="organization" entityId={itemId} type="production" />
            </Group>
            <Group>
              <Field
                label="Laskuttava yhtiö"
                type="reference"
                referenceConfig={{ id: 'operatingCompany', options: { source: 'operating_company' } }}
                name={itemId + '.operating_company_id'}
                key={itemId + '.operating_company_id'}
                onChange={formUpdate}
                formState={formState}
              />
              <Field
                inputLabel="Organisaation sopimuksessa on erityisehtoja"
                type="checkbox"
                name={itemId + '.data.specialConditions'}
                onChange={formUpdate}
                formState={formState}
              />
              <Field
                inputLabel="Organisaatio omistaa palvelussa tuotetut IPR"
                type="checkbox"
                name={itemId + '.data.ipr'}
                onChange={formUpdate}
                formState={formState}
              />
              <Field
                inputLabel="Widgetit käytössä"
                type="checkbox"
                name={itemId + '.data.widgetsEnabled'}
                onChange={formUpdate}
                formState={formState}
              />
            </Group>
            <Group>
              <Field
                label="Asiakasvastaava"
                type="reference"
                referenceConfig={{ id: 'organizationUser', options: { source: 'user' } }}
                name={itemId + '.data.userOwner'}
                key={itemId + '.data.userOwner'}
                onChange={formUpdate}
                formState={formState}
              />
              <Field
                label="Myyjä"
                type="reference"
                referenceConfig={{ id: 'organizationUser', options: { source: 'user' } }}
                name={itemId + '.data.userSeller'}
                key={itemId + '.data.userSeller'}
                onChange={formUpdate}
                formState={formState}
              />
            </Group>
            <Group>
              <Field
                label="Vanhat materiaalit (linkki tulee näkyviin aineistot.kokemuksia.fi)"
                type="text"
                name={itemId + '.data.oldMaterial'}
                onChange={formUpdate}
                formState={formState}
              />
            </Group>
          </div>
        </div>
        <div className="datatable-action-buttons datatable-action-buttons--flex">
          <div>
            <Submit content="Tallenna" icon="save" color="green" />
            <button className="datatable-action-button-cancel" onClick={e => e.preventDefault() & onCancel()}>
              Sulje
            </button>
          </div>
          <div></div>
        </div>
      </Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    isAdmin: state.authUser.admin === true,
    roleFeatures: state.authUser.roleFeatures,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    updateSuccess: (table_id, item_id, item) => dispatch(dataTableItemUpdateSuccess(table_id, item_id, item)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationEdit)
